import styled from 'styled-components'
import { colours } from '@qflow/theme'

export const Estimate = styled.span`
  display: inline-block;
  padding: 0.125rem 0.5rem;
  border-radius: 3px;

  color: ${colours.ORANGE};
  background-color: ${colours.CONSTRUCTION_ORANGE_BACKGROUND};
`
export const Actual = styled(Estimate)`
  color: ${colours.GREEN};
  background-color: ${colours.GREEN_BACKGROUND};
`
